import React from 'react';
import CGamePage from './CGamePage';
import BlockFillPage from './BlockFillPage';

const CBlockFill = () => <CGamePage gameKey="blockfill" title="Block Fill" page={BlockFillPage} />;

export default CBlockFill;
